const baseStyle = {
  maxW: "7xl",
  px: { base: "4", md: "6" },
};

export default { baseStyle };
